import React, { useContext, useState } from "react";
import { makeStyles, Typography, Grid } from "@material-ui/core";

import ModalParceiro from "./ModalParceiro";
import ModalParceiroM from "./ModalParceiroM";
import DeleteButton from "./DeleteButton";

import { SponsorContext } from "../context/Sponsorcontext";

export default function EditParceiro() {
  const classes = useStyles();
  const [expanded, setExpanded] = useState(false);

  const { sponsors, insertSponsorLoading, deleteLoading, deleteSponsor } =
    useContext(SponsorContext);

  const handleDelete = async (id) => {
    await deleteSponsor(id);
  };

  return (
    <div className={classes.root}>
      <div
        className={classes.addplan}
        onClick={() => setExpanded((v) => !v)}
        role="button"
        tabIndex={0}
      >
        <Typography className={classes.tituloD}>Parceiros</Typography>
        {expanded ? <ModalParceiro /> : null}
      </div>
      <div
        className={classes.addplanM}
        onClick={() => setExpanded((v) => !v)}
        role="button"
        tabIndex={0}
      >
        <Typography className={classes.tituloM}>Parceiros</Typography>
        <div className={classes.modalD}>
          {expanded ? <ModalParceiro /> : null}
        </div>
        <div className={classes.modalM}>
          {expanded ? <ModalParceiroM /> : null}
        </div>
      </div>
      {expanded && !insertSponsorLoading && !deleteLoading ? (
        <Grid container className={classes.container} spacing={4}>
          {sponsors.length > 0 &&
            sponsors.map((sponsor, index) => (
              <Grid key={sponsor.id} item xs={12} sm={6} md={4}>
                <div className={classes.item}>
                  <img
                    src={sponsor.logo || sponsor.image_url}
                    alt="Imagem do parceiro"
                    className={classes.img}
                  />
                  <div className={classes.editbuttons}>
                    <div className={classes.modalD}>
                      <ModalParceiro
                        fileNome={sponsor.logo}
                        nome={sponsor.name}
                        link={sponsor.website}
                        url={sponsor.logo}
                        id={sponsor.id}
                        description={sponsor.description}
                      />
                    </div>
                    <div className={classes.modalM}>
                      <ModalParceiroM
                        fileNome={sponsor.logo}
                        nome={sponsor.name}
                        link={sponsor.website}
                        url={sponsor.logo}
                        id={sponsor.id}
                        description={sponsor.description}
                      />
                    </div>
                    <DeleteButton id={sponsor.id} onDelete={handleDelete} />
                  </div>
                </div>
              </Grid>
            ))}
        </Grid>
      ) : (
        expanded ? <div style={{ fontSize: 20, margin: 40 }}>Carregando...</div> : null
      )}
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    flexDirection: "column",
    alignItems: "center",
    display: "flex",
  },
  addplan: {
    marginTop: "28px",
    width: "100%",
    height: "70px",
    backgroundColor: theme.colors.darkBlue,
    alignItems: "center",
    justifyContent: "space-between",
    paddingLeft: "40px",
    paddingRight: "20px",
    display: "flex",
    cursor: 'pointer',
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  addplanM: {
    marginTop: "24px",
    width: "100%",
    height: "45px",
    backgroundColor: theme.colors.darkBlue,
    alignItems: "center",
    justifyContent: "space-between",
    paddingLeft: "10px",
    paddingRight: "10px",
    display: "flex",
    cursor: 'pointer',
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
  },
  img: {
    height: "140px",
  },
  addimg: {
    height: "21px",
  },
  addbutton: {
    maxWidth: "21px",
  },
  tituloD: {
    font: "Karla",
    fontSize: "32px",
    color: theme.colors.white,
  },
  tituloM: {
    font: "Karla",
    fontSize: "20px",
    color: theme.colors.white,
  },
  item: {
    height: "100%",
    width: "100%",
    alignItems: "center",
    flexDirection: "column",
    display: "flex",
  },
  editbuttons: {
    marginTop: "11px",
    width: "100%",
    justifyContent: "center",
    gap: "24px",
    flexDirection: "row",
    display: "flex",
    alignItems: "center",
  },
  editbuttom: {
    height: "24px",
    width: "24px",
  },
  deleteButton: {
    height: "24px",
    width: "24px",
    padding: "0px",
  },
  container: {
    marginTop: "28px",
    direction: "row",
    alignItems: "center",
    display: "flex",
  },
  modalD: {
    [theme.breakpoints.down("xs")]: {
      display: "none",
    },
  },
  modalM: {
    [theme.breakpoints.up("sm")]: {
      display: "none",
    },
  },
}));
